import { useEffect } from 'react';
import { useNotifications } from './useNotifications';

interface AdminNotification {
  id: number;
  title: string;
  body: string;
  type: 'general' | 'reminder' | 'urgent';
  timestamp: string;
  from: 'admin';
}

export const useAdminNotifications = () => {
  const { showNotification } = useNotifications();

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'admin_notification' && event.newValue) {
        try {
          const notification: AdminNotification = JSON.parse(event.newValue);
          
          // Mostrar la notificación recibida del admin
          showNotification({
            title: notification.title,
            body: notification.body,
            icon: '/logo192.png',
            tag: `admin-${notification.id}`,
            requireInteraction: notification.type === 'urgent'
          });

          // Log para debugging
          console.log('Notificación recibida del admin:', notification);
          
        } catch (error) {
          console.error('Error procesando notificación del admin:', error);
        }
      }
    };

    // Escuchar cambios en localStorage (para notificaciones cross-tab)
    window.addEventListener('storage', handleStorageChange);

    // También verificar si hay una notificación pendiente al cargar
    const checkPendingNotification = () => {
      const pendingNotification = localStorage.getItem('admin_notification');
      if (pendingNotification) {
        try {
          const notification: AdminNotification = JSON.parse(pendingNotification);
          
          // Solo mostrar si es reciente (menos de 5 segundos)
          const notificationTime = new Date(notification.timestamp).getTime();
          const now = Date.now();
          
          if (now - notificationTime < 5000) {
            showNotification({
              title: notification.title,
              body: notification.body,
              icon: '/logo192.png',
              tag: `admin-${notification.id}`,
              requireInteraction: notification.type === 'urgent'
            });
          }
        } catch (error) {
          console.error('Error procesando notificación pendiente:', error);
        }
      }
    };

    // Verificar notificación pendiente al cargar
    checkPendingNotification();

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [showNotification]);
};

export default useAdminNotifications;